<template>
<div>
    <Breadcrumbs main="Finance & Accounts" submain="Finance" title="Purchase Order Edit" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <px-card>
                    <div slot="with-padding">
                        <div class="form theme-form">

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Vendor<span><button class="btn-success ml-3" v-b-modal.modal-prevent-closing>Add New</button></span></label>
                                        <!-- <select class="form-control digits" v-model="purchase_order.vendor" @change="getVendor">
                                            <option v-for="(vendor, index) in vendors" :key="index" :value="vendor.user.id">{{ vendor.user.user_name }}</option>
                                        </select> -->
                                        <v-select
                                            class="custom-vue-select"
                                            :options="vendors"
                                            :get-option-label="vendorLabel"
                                            :reduce="vendor => vendor.user.id"
                                            v-model="purchase_order.vendor"
                                            @input="getVendor"
                                            placeholder="Select a vendor"
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Project</label>
                                        <!-- <select class="form-control digits" v-model="purchase_order.project">
                                            <option v-for="(project, index) in projects" :key="index" :value="project.id">{{ project.title }}</option>
                                        </select> -->
                                        <v-select
                                            class="custom-vue-select"
                                            :options="projects"
                                            label="title"
                                            :reduce="project => project.id"
                                            v-model="purchase_order.project"
                                            placeholder="Select a project"
                                        ></v-select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Email</label>
                                        <input class="form-control" type="text" placeholder="Enter email address" v-model="purchase_order.email">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Currency</label>
                                        <select class="form-control digits" v-model="purchase_order.currency">
                                            <option v-for="(currency, index) in currencies" :key="index">{{ currency }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Vendor Address</label>
                                        <input class="form-control" type="text" placeholder="Enter vendor address" v-model="purchase_order.vendor_address">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Billing Address</label>
                                        <input class="form-control" type="text" placeholder="Enter billing address" v-model="purchase_order.billing_address">
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Purchase Order Date</label>
                                        <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" v-model="purchase_order.purchase_order_date"></datepicker>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Due Date</label>
                                        <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" v-model="purchase_order.due_date"></datepicker>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Upload Attachment</label>
                                        <b-form-file v-model="purchase_order.purchase_order_attachment" placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." @change="uploadFile"></b-form-file>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Items</label>
                                        <ItemTable v-if="purchase_order.details" style="margin-bottom: 10px;" id="item-table" :tableData="purchase_order.details" @itemsUpdated="updateItems" />
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-4"></div>
                                <div class="col-sm-8">
                                    <!-- Total -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Total</label>
                                        <input class="form-control" type="number" placeholder="Enter total amount" disabled v-model="purchase_order.total" />
                                    </div>

                                    <!-- Vat -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Vat (%)</label>
                                        <div class="d-flex w-100  flex-lg-nowrap flex-wrap" style="gap:16px">
                                             <div class="w-100">
                                                <select class="form-control digits" v-model="purchase_order.vat_type">
                                                    <option disabled value="">Select Vat Type</option>
                                                    <option v-for="(type, index) in vat_type" :key="index" :value="type.value">{{ type.title }}</option>
                                                </select>
                                                <small class="text-danger" v-if="errors.vat_type">{{ errors.vat_type }}</small>

                                            </div>
                                            <div class="w-100">
                                                <input class="form-control" type="number" placeholder="Enter vat (%)" v-model="purchase_order.vat" />
                                                <small class="text-danger" v-if="errors.vat">{{ errors.vat }}</small>
                                            </div>
                                            <input class="form-control" type="number" placeholder="Vat Amount" v-model="vatAmount" disabled />
                                        </div>
                                    </div>

                                    <!-- Tax -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Tax (%)</label>
                                        <div class="d-flex w-100  flex-lg-nowrap flex-wrap" style="gap:16px">
                                             <div class="w-100">
                                                <select class="form-control digits" v-model="purchase_order.tax_type">
                                                    <option disabled value="">Select Tax Type</option>
                                                    <option v-for="(type, index) in vat_type" :key="index" :value="type.value">{{ type.title }}</option>
                                                </select>
                                                <small class="text-danger" v-if="errors.tax_type">{{ errors.tax_type }}</small>

                                            </div>
                                            <div class="w-100">
                                                <input class="form-control" type="number" placeholder="Enter tax (%)" v-model="purchase_order.tax" />
                                                <small class="text-danger" v-if="errors.tax">{{ errors.tax }}</small>
                                            </div>
                                            <input class="form-control" type="number" placeholder="Tax Amount" v-model="taxAmount" disabled />
                                        </div>
                                    </div>

                                    <!-- Discount -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Discount (%)</label>
                                        <div class="d-flex w-100" style="gap:16px">
                                            <input class="form-control" type="number" placeholder="Enter discount (%)" v-model="purchase_order.discount" />
                                            <input class="form-control" type="number" placeholder="Tax Amount" v-model="discountAmount" disabled />
                                        </div>
                                    </div>

                                    <!-- Grand Total -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Grand Total ({{ purchase_order.currency ? purchase_order.currency : "BDT" }})</label>
                                        <input class="form-control" type="number" placeholder="Enter grand total" disabled v-model="purchase_order.subtotal" />
                                    </div>

                                    <!-- In Words -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">In Words</label>
                                        <input class="form-control" type="text" placeholder="Enter grand total in words" v-model="purchase_order.in_words" />
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Remarks</label>
                                        <textarea class="form-control" id="exampleFormControlTextarea4" placeholder="Enter remarks..." rows="2" v-model="purchase_order.remarks"></textarea>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group mb-0">
                                        <button @click="validateType" class="btn btn-success mr-3">Submit</button>
                                        <router-link to="/finance-and-accounts/finance/purchase-order/list">
                                            <button class="btn btn-danger" href="#">Go Back</button>
                                        </router-link>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </px-card>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Vendor Create -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add New Vendor" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit">
            <b-form-group label="First Name" label-for="name-input" invalid-feedback="Item is required">
                <b-form-input id="name-input" v-model="item.first_name" placeholder="Enter first name"></b-form-input>
            </b-form-group>
            <b-form-group label="Last Name" label-for="name-input" invalid-feedback="Item is required">
                <b-form-input id="name-input" v-model="item.last_name" placeholder="Enter last name"></b-form-input>
            </b-form-group>

            <div class="form-group">
                <label>Category</label>
                <multiselect v-model="category" tag-placeholder="Add Category" placeholder="Search or add a category" label="title" :max="vendor_categories.length" track-by="id" :options="vendor_categories" :multiple="true" :taggable="true"></multiselect>
            </div>

            <b-form-group label="Email" label-for="name-input" invalid-feedback="Email is required">
                <b-form-input id="name-input" v-model="item.email" placeholder="Enter email address"></b-form-input>
            </b-form-group>
            <b-form-group label="Phone No" label-for="name-input" invalid-feedback="Phone no is required">
                <b-form-input id="name-input" v-model="item.phone" placeholder="Enter phone number"></b-form-input>
            </b-form-group>
            <b-form-group label="Company" label-for="name-input" invalid-feedback="Company is required">
                <b-form-input id="name-input" v-model="item.company" placeholder="Enter company name"></b-form-input>
            </b-form-group>
            <b-form-group label="Address" label-for="name-input" invalid-feedback="Address is required">
                <b-form-input id="name-input" v-model="item.address" placeholder="Enter address"></b-form-input>
            </b-form-group>
        </form>
    </b-modal>
</div>
</template>

<script>
import { mapState } from 'vuex';
import { computed } from "vue";
import ItemTable from "../items-table/edit-item-table.vue";
import moment from "moment";
import Multiselect from 'vue-multiselect';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {
    components: {
        vueDropzone: vue2Dropzone,
        Datepicker,
        ItemTable,
        Multiselect,
        'v-select': vSelect
    },

    data() {
        return {
            discountAmount: computed(() => {
                if (this.purchase_order.total !== 0) {
                    const discount = this.purchase_order.discount || 0;
                    let total = this.purchase_order.total + discount * (this.purchase_order.total / 100)
                    let gtotal = total - this.purchase_order.total

                    return Math.round((gtotal + Number.EPSILON) * 100) / 100;
                }
                return 0;
            }),
              basePrice: computed(() => {
                if (!this.purchase_order ?.total || !this.purchase_order ?.vat_type || !this.purchase_order ?.tax_type) return 0;

                const total = Number(this.purchase_order.total);
                const vat = Number(this.purchase_order.vat || 0);
                const tax = Number(this.purchase_order.tax || 0);

                if (this.purchase_order.vat_type === 'inclusive' && this.purchase_order.tax_type === 'inclusive') {
                    const divisor = 1 + (vat + tax) / 100;
                    const base = total / divisor;
                    return Math.round((base + Number.EPSILON) * 100) / 100;
                }

                let divisor = 1;
                if (this.purchase_order.vat_type === 'inclusive') {
                    divisor += vat / 100;
                }
                if (this.purchase_order.tax_type === 'inclusive') {
                    divisor += tax / 100;
                }

                const base = total / divisor;
                return Math.round((base + Number.EPSILON) * 100) / 100;
            }),

            taxAmount: computed(() => {
                if (this.purchase_order ?.tax && this.purchase_order ?.tax_type && this.purchase_order ?.total) {
                    const vat = Number(this.purchase_order.tax);
                    return Math.round((this.basePrice * vat / 100 + Number.EPSILON) * 100) / 100;
                }

                return 0;
            }),

            vatAmount: computed(() => {
                if (this.purchase_order ?.vat && this.purchase_order ?.vat_type && this.purchase_order ?.total) {
                    const vat = Number(this.purchase_order.vat);
                    return Math.round((this.basePrice * vat / 100 + Number.EPSILON) * 100) / 100;
                }

                return 0;
            }),
            purchase_order: {
                vendor: '',
                project: '',
                email: '',
                currency: 'BDT',
                vendor_address: '',
                billing_address: '',
                purchase_order_date: null,
                due_date: null,
                details: null,
                details_in_depth: [],
                total: computed(() => {
                    let total = 0;
                    if (this.purchase_order.details_in_depth.length >= 1) {
                        this.purchase_order.details_in_depth.map((item) => {
                            total = total + item.rate;
                        });
                    }
                    return total;
                }),
                vat: null,
                tax: null,
                 vat_type: '',
                tax_type: '',
                discount: null,
              subtotal: computed(() => {
                    if (!this.purchase_order ?.total || !this.purchase_order ?.vat_type || !this.purchase_order ?.tax_type) return 0;

                    const total = Number(this.purchase_order.total);
                    const discount = Number(this.purchase_order.discount || 0);

                    // Case 1: both VAT and TAX are inclusive → just apply discount to total
                    if (this.purchase_order.vat_type === 'inclusive' && this.purchase_order.tax_type === 'inclusive') {
                        const discounted = total - (total * discount / 100);
                        return Math.round((discounted + Number.EPSILON) * 100) / 100;
                    }

                    // Case 2: Exclusive taxes → add them first
                    let calculated = total;

                    if (this.purchase_order.vat_type === 'exclusive') {
                        calculated += this.vatAmount;
                    }

                    if (this.purchase_order.tax_type === 'exclusive') {
                        calculated += this.taxAmount;
                    }

                    // Apply discount to final calculated total
                    const discounted = calculated - (calculated * discount / 100);
                    return Math.round((discounted + Number.EPSILON) * 100) / 100;
                }),
                purchase_order_attachment: null,
                in_words: '',
                remarks: ''
            },

            vendor: {
                name: '',
                company: '',
                designation: '',
                phone: '',
                email: '',
                status: 'Active'
            },

            category: [],

            item: {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                category: [],
                company: '',
                address: '',
                status: true
            },

              vat_type: [{
                    id: 1,
                    value: "inclusive",
                    title: "Inclusive",
                },
                {
                    id: 2,
                    value: "exclusive",
                    title: "Exclusive",
                }
            ],
            errors: {
                vat_type: '',
                tax_type: '',
                tax: '',
                vat: '',
            },

            currencies: ['BDT', 'USD', 'EUR']
        };
    },

    computed: {
        ...mapState({
            detail: state => state.purchase_order.purchase_order_detail,
            items: state => state.item.items,
            projects: state => state.project.project,
            vendors: state => state.vendor.vendor_without_pg,
            vendor_categories: state => state.vendor.vendor_categories
        })
    },

    mounted() {
        this.$store.dispatch("purchase_order/fetchPODetail", this.$route.params.id)
        this.$store.dispatch("item/fetchItem")
        this.$store.dispatch("project/fetchProject")
        this.$store.dispatch("vendor/fetchVendor_without_pg")
        this.$store.dispatch("vendor/fetchVendorCategory")
    },

    watch: {
        detail(oldValue, newValue) {
            this.purchase_order.email = this.detail.email
            this.purchase_order.currency = this.detail.currency
            this.purchase_order.vendor_address = this.detail.vendor_address
            this.purchase_order.billing_address = this.detail.billing_address
            this.purchase_order.purchase_order_date = this.detail.purchase_order_date
            this.purchase_order.due_date = this.detail.due_date

            this.purchase_order.total = this.detail.total
            this.purchase_order.vat = this.detail.vat
            this.purchase_order.tax = this.detail.tax

             this.purchase_order.vat_type = this.detail.vat_type
            this.purchase_order.tax_type = this.detail.tax_type
            this.purchase_order.discount = this.detail.discount
            this.purchase_order.subtotal = this.detail.subtotal
            this.purchase_order.in_words = this.detail.in_words
            this.purchase_order.remarks = this.detail.remarks
            this.purchase_order.vendor = this.detail.vendor.id
            this.purchase_order.project = this.detail.project.id

            if (this.detail.details !== null && this.detail.details !== undefined) {
                this.purchase_order.details = JSON.parse(this.detail.details);
                this.purchase_order.details_in_depth = this.purchase_order.details
            }
            // this.purchase_order.details = JSON.parse(this.detail.details)

            this.purchase_order.purchase_order_attachment = this.detail.purchase_order_attachment
        }
    },

    methods: {
        validateType() {
            this.errors = {
                vat_type: '',
                tax_type: '',
                tax: '',
                vat: '',
            };

            let valid = true;

            if (!this.purchase_order.vat_type) {
                this.errors.vat_type = 'Vat type is required.';
                valid = false;
            }
            if (!this.purchase_order.tax_type) {
                this.errors.tax_type = 'Tax type is required.';
                valid = false;
            }
            if (!this.purchase_order.vat) {
                this.errors.vat = 'Vat is required.';
                valid = false;
            }
            if (!this.purchase_order.tax) {
                this.errors.tax = 'Tax is required.';
                valid = false;
            }

            if (valid) {
                this.onSubmit();
            }
        },
        vendorLabel(vendor) {
            return vendor?.user?.user_name || null
        },

        getVendor() {
            this.$store.dispatch("vendor/fetchVendorByUserId", this.purchase_order.vendor).then(result => {
                this.purchase_order.email = result.data.user.email
                this.purchase_order.vendor_address = result.data.address
                this.purchase_order.billing_address = result.data.address
            })
        },

        updateItems(data) {
            if (data) {
                this.purchase_order.details = data;
                this.purchase_order.details_in_depth = data;
            }
        },

        uploadFile(e) {
            this.purchase_order.purchase_order_attachment = e.target.files[0];
        },

        onSubmit() {
            if (this.purchase_order.purchase_order_date !== null) {
                this.purchase_order.purchase_order_date = moment(String(this.purchase_order.purchase_order_date)).format("YYYY-MM-DD");
            }
            if (this.purchase_order.due_date !== null) {
                this.purchase_order.due_date = moment(String(this.purchase_order.due_date)).format("YYYY-MM-DD");
            }

            this.$store.dispatch("purchase_order/updatePO", {
                id: this.$route.params.id,
                purchase_order: this.purchase_order
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    setTimeout(() => {
                        this.$router.push('/finance-and-accounts/finance/purchase-order/list')
                    }, 2000)

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        resetModal() {
            this.item.first_name = ''
            this.item.last_name = ''
            this.item.email = ''
            this.item.phone = ''
            this.item.company = ''
            this.item.address = ''
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            this.category.map(item => this.item.category.push(item.id));
            this.$store.dispatch("vendor/addVendor", {item:this.item}).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.purchase_order.vendor = response.data.user
                    this.purchase_order.email = response.data.email
                    this.purchase_order.vendor_address = response.data.address
                    this.purchase_order.billing_address = response.data.address

                    this.item.first_name = ''
                    this.item.last_name = ''
                    this.item.email = ''
                    this.item.phone = ''
                    this.item.company = ''
                    this.item.address = ''

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        }
    }
};
</script>
<style>
</style>